import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonComponent, ModalData, ModalRef } from '@ui-lib/components';
import { TranslateModule } from '@ngx-translate/core';
import { IConfirmationDialogData } from './confirmation-dialog-data.interface';

@Component({
  selector: 'mon-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TranslateModule],
})
export class ConfirmationDialogComponent extends ModalData<IConfirmationDialogData> {
  private readonly modalRef = inject(ModalRef<boolean>);

  /**
   * Отменить
   */
  public cancel(): void {
    this.modalRef.close(false);
  }

  /**
   * Подтвердить
   */
  public confirm(): void {
    this.modalRef.close(true);
  }
}
